/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/events/event
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import { ShopifyEventKey, ShopifyEventToShopKey, ShopifyShopKey } from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyEventKey,
  "2022-01": {
    name: "Shopify Event",
    fields: [
      {
        name: "Arguments",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "arguments" } },
      },
      {
        name: "Author",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "author" } },
      },
      {
        name: "Body",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "body" } },
      },
      {
        name: "Description",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "description" } },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Message",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "message" } },
      },
      {
        name: "Path",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "path" } },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyEventToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at" } },
      },
      {
        name: "Subject ID",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "subject_id" } },
      },
      {
        name: "Subject Type",
        fieldType: FieldType.Enum,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "subject_type" } },
        configuration: {
          allowMultiple: false,
          allowOther: true,
          options: [
            { name: "ApiPermission" },
            { name: "Article" },
            { name: "Blog" },
            { name: "Collection" },
            { name: "Comment" },
            { name: "Order" },
            { name: "Page" },
            { name: "PriceRule" },
            { name: "Product" },
          ],
        },
      },
      {
        name: "Verb",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "verb" } },
      },
    ],
    syncConfig: { type: "rest_list", resource: "event" },
  },
  "2025-04": {
    graphQLTypename: "Event",
    fields: [
      {
        name: "Arguments",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "arguments", graphQLFieldKey: "arguments", graphQLFragments: ["BasicEvent"] },
        },
      },
      {
        name: "Author",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "author" } },
        isDeleted: true,
      },
      {
        name: "Body",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "body" } },
        isDeleted: true,
      },
      {
        name: "Description",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "description" } },
        isDeleted: true,
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "id", graphQLFieldKey: "id" },
        },
      },
      {
        name: "Message",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "message",
            graphQLFieldKey: "message",
          },
        },
      },
      {
        name: "Path",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "path" } },
        isDeleted: true,
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyEventToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "created_at",
            graphQLFieldKey: "createdAt",
          },
        },
      },
      {
        name: "Basic Event Subject ID",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "subjectId", graphQLFragments: ["BasicEvent"] } },
      },
      {
        name: "Comment Event Subject ID",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "subject", graphQLSelection: "id", graphQLFragments: ["CommentEvent"] },
        },
      },
      {
        name: "Subject ID",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "subject_id" } },
        isDeleted: true,
      },
      {
        name: "Subject Type",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "subject_type",
            graphQLFieldKey: "subjectType",
            graphQLFragments: ["BasicEvent"],
            isShopifyEnum: true,
          },
        },
        configuration: {
          allowMultiple: false,
          allowOther: true,
          options: [
            { name: "ARTICLE" },
            { name: "BLOG" },
            { name: "COLLECTION" },
            { name: "COMMENT" },
            { name: "COMPANY" },
            { name: "COMPANY_LOCATION" },
            { name: "CUSTOMER" },
            { name: "DISCOUNT_AUTOMATIC_BXGY" },
            { name: "DISCOUNT_AUTOMATIC_NODE" },
            { name: "DISCOUNT_CODE_NODE" },
            { name: "DISCOUNT_NODE" },
            { name: "DRAFT_ORDER" },
            { name: "ORDER" },
            { name: "PAGE" },
            { name: "PRICE_RULE" },
            { name: "PRODUCT" },
            { name: "PRODUCT_VARIANT" },
            { name: "UNKNOWN" },
          ],
        },
      },
      {
        name: "Verb",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "verb" } },
        isDeleted: true,
      },
      {
        name: "Action",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "action" } },
      },
      {
        name: "App Title",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "appTitle" } },
      },
      {
        name: "Attribute To App",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "attributeToApp" } },
      },
      {
        name: "Attribute To User",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "attributeToUser" } },
      },
      {
        name: "Crtical Alert",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "criticalAlert" } },
      },
      {
        name: "Additional Content",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "additionalContent", graphQLFragments: ["BasicEvent"] } },
      },
      {
        name: "Additional Data",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "additionalData", graphQLFragments: ["BasicEvent"] } },
      },
      {
        name: "Has Additional Content",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "hasAdditionalContent", graphQLFragments: ["BasicEvent"] } },
      },
      {
        name: "Can Delete",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "canDelete", graphQLFragments: ["CommentEvent"] } },
      },
      {
        name: "Can Edit",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "canEdit", graphQLFragments: ["CommentEvent"] } },
      },
      {
        name: "Edited",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "edited", graphQLFragments: ["CommentEvent"] } },
      },
      {
        name: "Embed",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "edited", graphQLFragments: ["CommentEvent"] } },
      },
      {
        name: "Raw Message",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "rawMessage", graphQLFragments: ["CommentEvent"] } },
      },
    ],
    syncConfig: {
      type: "graphql_list",
      resource: "events",
      filters: {
        createdAt: { sortKey: "CREATED_AT" },
      },
      sortableBy: {
        createdAt: { sortKey: "CREATED_AT", reverse: true },
        id: { sortKey: "ID", reverse: false },
      },
    },
  },
};

export const ShopifyEvent = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
